import { ArrowUp, ArrowUpRight } from "lucide-react";
import { APP_URL } from "@/components/SiteNav";
import { Reveal } from "@/components/Reveal";
import { useCountUp } from "@/lib/useCountUp";
import { euro } from "@/lib/format";
import { scrollToId } from "@/lib/scroll";
import { CONTACT_EMAIL } from "@/components/aziende/plans";

const Headline = ({ diff }) => {
  const v = useCountUp(Math.max(diff, 0));
  if (diff <= 0)
    return <>Con questi numeri i costi si equivalgono. <span className="text-cyan">La differenza la fanno i dati.</span></>;
  return <>Con questi numeri risparmi <span className="text-cyan calc-glow" data-testid="calc-close-amount" data-value={Math.round(diff)}>{euro(v)}</span> all'anno. Ne parliamo?</>;
};

export const CalcClose = ({ diff, plan }) => {
  return (
    <Reveal className="mt-12 lg:mt-16">
      <div className="bridge-panel glass rounded-[28px] border p-7 sm:p-12 text-center" data-testid="calc-close">
        <h3 className="mx-auto max-w-3xl font-extrabold tracking-[-0.035em] leading-[1.1] text-2xl sm:text-4xl text-white" data-testid="calc-close-title">
          <Headline diff={diff} />
        </h3>
        <p className="mx-auto mt-5 max-w-2xl text-sm sm:text-base leading-relaxed text-titanium">
          {diff > 0
            ? `Il piano ${plan.name} ha un prezzo fisso e nessuna fee sulle assunzioni. Richiedi l'accesso e attivalo in autonomia.`
            : "Con Prodigy ottieni l'analisi psicometrica e l'archetipo di ogni candidato: informazioni che nessuna agenzia ti fornisce. Ti aiutiamo a scegliere il piano giusto."}
        </p>
        <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4">
          <a href={APP_URL} target="_blank" rel="noopener noreferrer" className="cta cta-mega glass inline-flex w-full sm:w-auto min-h-[52px] items-center justify-center gap-2 rounded-full border px-8 py-4 text-sm sm:text-base font-bold text-white" data-testid="calc-close-activate">
            Richiedi l'accesso <ArrowUpRight className="h-4 w-4 text-cyan" />
          </a>
          <button
            type="button"
            onClick={() => scrollToId("piani")}
            className="cta cta-ghost glass inline-flex w-full sm:w-auto min-h-[52px] items-center justify-center gap-2 rounded-full border px-8 py-4 text-sm sm:text-base font-semibold text-white/85"
            data-testid="calc-close-review"
          >
            <ArrowUp className="h-4 w-4 text-cyan" /> Rivedi i piani
          </button>
        </div>
        <p className="mt-7 text-sm text-[#6b7078]">
          Oppure scrivici a{" "}
          <a href={`mailto:${CONTACT_EMAIL}`} className="footer-link inline-block py-2 text-titanium underline underline-offset-4 decoration-[#2a2d33]" data-testid="calc-close-email">
            {CONTACT_EMAIL}
          </a>
        </p>
      </div>
    </Reveal>
  );
};
